import { createContext } from "react";

const MeetingContext = createContext();

export { MeetingContext };